module.exports = __webpack_public_path__ + "static/bodak-c3456ad4f808c5a6d59b30f0e91aaf98.jpeg";